@if (recommendations$|async; as recommendations) {
  <app-product-carousel eventSourceName="related-products"
                        [products]="recommendations"/>
}
